<template>
	<div>
		<div class="banner">
			<div class="title">
				<div class="backColor"></div>
				<div class="overlay">为 全 球 企 业 提 供 高 速、稳 定、安 全、专 业 的 NaaS 解 决 方 案</div>
			</div>
		</div>

		<!-- ZO-SASE -->
		<div id="ZO-SASE"></div>
		<div class="container">
			<div class="leftRight"></div>
			<section class="center">
				<div style="color: #4B4B4B;">
					<div class="module_title">ZO-SASE</div>
					<el-image :src="saseImg" style="width: 100%;height: 470px"></el-image>
				</div>
			</section>
			<div class="leftRight"></div>
		</div>

		<!-- ZO-Net -->
		<div id="ZO-Net"></div>
		<div class="container">
			<div class="leftRight"></div>
			<section class="center">
				<div style="color: #4B4B4B;">
					<div class="module_title">ZO-Net</div>
					<el-image :src="netImg" style="width: 100%;height: 580px"></el-image>
					<div class="module_title">金融专网</div>
					<el-image style="width: 100%;height: 590px" :src="networkImg"></el-image>
				</div>
			</section>
			<div class="leftRight"></div>
		</div>

		<!-- ZO-Cloud -->
		<div id="ZO-Cloud"></div>
		<div class="container" style="margin-bottom: 60px">
			<div class="leftRight"></div>
			<section class="center">
				<div style="color: #4B4B4B;">
					<div class="module_title">ZO-Cloud</div>
					<el-image :src="cloudImg" style="width: 100%;height: 598px"></el-image>
				</div>
			</section>
			<div class="leftRight"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				saseImg: require('@/assets/solute/sasesolute.jpg'),
				netImg: require('@/assets/solute/netsolute.jpg'),
				cloudImg: require('@/assets/solute/cloudsolute.jpg'),
				networkImg: require('@/assets/solute/network.jpg'),
			}
		},
		mounted() {
			// 在页面加载完成后执行
    	this.handleUrlParams();
		},
		methods: {
			handleUrlParams() {
				const targetValue = this.$route.query.name;

				if (targetValue) {
					// Use Vue.nextTick to make sure the DOM is updated before scrolling
					this.$nextTick(() => {
						const targetElement = document.getElementById(targetValue);
						
						if (targetElement) {
							window.scrollTo({
								top: targetElement.offsetTop,
								behavior: 'smooth',
							});
						}
					});
				}
			},
		},
	}
</script>

<style scoped  lang="scss">
/* 圣杯布局 */
.container {
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  flex: 1;
}
.center {
  flex: 0 0 1200px;
}
.leftRight {
  flex: 1;
}

/* banner图 */
.banner {
  height: 55vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../assets/solute/banner.jpg") no-repeat;
  background-size: cover;// 全覆盖
	background-position: center; //指定元素背景图片的位置  
	.title{
		position: relative;
		.backColor {
			width: 885px;
			height: 46px;
			background-color: rgba(248, 242, 242, 0.2);
			backdrop-filter: blur(5px); /* 调整模糊程度 */
		}
		.overlay {
			position: absolute;
			top: 2px;
			left: 15px;
			color: white;
			font-size: 28px;
			font-weight: 400;
		}
	}
}

// @media (max-width: 1000px) {
//   .banner {
//     background-size: contain;
//   }
// }
// @media (min-width: 1000px) {
//   .banner {
//     background-size: cover;
//     background-position: center center;
//   }
// }

.module_title {
  font-size: 28px;
  font-weight: bold;
  color: #4B4B4B;
  text-align: center;
  margin: 30px 0 40px 0;
}
</style>

<style scope>
.el-carousel__button {
	width: 10px;
	height: 10px;
	border-radius: 50%;
}
</style>
